import React from 'react'
import PropTypes from 'prop-types'
import { Column, Columns, SecondaryButton, PrimaryButton, Level, LevelLeft, LevelItem, LevelRight } from '../../../bulma'
import { CouponIcon } from '../../../core/icons'

/**
 * Item added to cart info.
 *
 * @param {object} props - Component props.
 * @returns {function} Component
 */
function ItemAddedCart(props) {
  const { order } = props
  const totalItems = order.line_items.reduce((sum, item) => sum + item.quantity, 0)
  const itemWording = totalItems === 1
    ? 'item'
    : 'items'

  return (
    <Column className="has-text-centered">
      <h2 className="sans-serif">
        Cart subtotal ({totalItems} {itemWording}) <strong>{order.display_item_total}</strong>
      </h2>
      <Columns>
        <Column>
          <PrimaryButton href="/checkout" linkRef="item-added" isFullwidth>Proceed To Checkout</PrimaryButton>
        </Column>
      </Columns>
      <Columns isMultiline isMobile>
        <Column>
          <SecondaryButton
            href="/products?filters[prices][from]=0.50"
            linkRef="item-added"
            isOutlined
            isFullwidth
          >
            Continue Shopping
          </SecondaryButton>
        </Column>
        <Column>
          <SecondaryButton
            href="/cart"
            linkRef="item-added"
            isOutlined
            isFullwidth
          >
            View Cart
          </SecondaryButton>
        </Column>
      </Columns>
      <div>
        <Level isMobile className="coupon-message">
          <LevelLeft />
          <LevelLeft>
            <LevelItem><CouponIcon className="has-fill-primary" /></LevelItem>
            <LevelItem canWrapContent>
              <div>Coupons will be applied on the payment page</div>
            </LevelItem>
          </LevelLeft>
          <LevelRight />
        </Level>
      </div>
    </Column>
  )
}

ItemAddedCart.defaultProps = {
  order: {},
}

ItemAddedCart.propTypes = {
  // The order being placed
  order: PropTypes.shape({
    display_item_total: PropTypes.string,
    line_items: PropTypes.array,
  }),
}

export default ItemAddedCart
